import c from "./constants";
import { setUserData } from "../user";
import { getCurrentUserInfoService } from "../user/services";

export function getCurrentUserInfo() {
  const begin = () => ({ type: c.GET_CURRENT_USER_BEGIN });
  const success = () => ({ type: c.GET_CURRENT_USER_SUCCESS });
  const failure = error => ({
    type: c.GET_CURRENT_USER_FAILURE,
    payload: error,
  });

  return async dispatch => {
    dispatch(begin());
    getCurrentUserInfoService()
      .then(data => {
        dispatch(setUserData(data));
        dispatch(success());
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };
}



// WEBPACK FOOTER //
// ./src/modules/menu/actions.js